/**
 * Sales Primer translations, 4 languages.
 * English (en), Arabic MSA (ar, RTL), Ukrainian (uk), Russian (ru).
 *
 * Keep all strings here. The page consumes via t(key).
 */

export const LANGUAGES = [
  { code: 'en', label: 'English', dir: 'ltr' },
  { code: 'ar', label: 'العربية', dir: 'rtl' },
  { code: 'uk', label: 'Українська', dir: 'ltr' },
  { code: 'ru', label: 'Русский', dir: 'ltr' },
];

export const TRANSLATIONS = {
  // ─── Cover ─────────────────────────────────────────────────────────
  cover_eyebrow: {
    en: 'Internal sales handbook · v1',
    ar: 'دليل المبيعات الداخلي · الإصدار ١',
    uk: 'Внутрішній посібник продавця · v1',
    ru: 'Внутреннее пособие продавца · v1',
  },
  cover_title: {
    en: 'Your 30-second guide to selling Keystone.',
    ar: 'دليلك في ٣٠ ثانية لبيع Keystone.',
    uk: 'Ваш 30-секундний посібник з продажу Keystone.',
    ru: 'Ваше 30-секундное руководство по продаже Keystone.',
  },
  cover_lede: {
    en: 'Read this once. Pin it above your desk. You will never sound like you don\'t know what we do.',
    ar: 'اقرأه مرة واحدة. علّقه فوق مكتبك. لن تبدو أبداً وكأنك لا تعرف ما نقوم به.',
    uk: 'Прочитайте один раз. Прикріпіть над столом. Ви ніколи більше не звучатимете так, ніби не розумієте, що ми робимо.',
    ru: 'Прочитайте один раз. Прикрепите над столом. Вы больше никогда не будете звучать так, будто не знаете, что мы делаем.',
  },
  cover_chip_what: { en: 'What it is', ar: 'ما هو', uk: 'Що це', ru: 'Что это' },
  cover_chip_who: { en: 'Who buys it', ar: 'من يشتريه', uk: 'Хто його купує', ru: 'Кто его покупает' },
  cover_chip_how: { en: 'How to talk', ar: 'كيف تتحدث', uk: 'Як говорити', ru: 'Как говорить' },
  cover_chip_hand: { en: 'How to hand over', ar: 'كيف تسلّم العميل', uk: 'Як передати лід', ru: 'Как передать лид' },

  // ─── Page 2, What is Keystone ────────────────────────────────────
  p2_section: { en: '02 · What Keystone is', ar: '٠٢ · ما هو Keystone', uk: '02 · Що таке Keystone', ru: '02 · Что такое Keystone' },
  p2_title: {
    en: 'Keystone is software for small food factories.',
    ar: 'Keystone هو برنامج لمصانع الأغذية الصغيرة.',
    uk: 'Keystone, це програмне забезпечення для невеликих харчових виробництв.',
    ru: 'Keystone, это программное обеспечение для небольших пищевых производств.',
  },
  p2_one_a: {
    en: 'They make food.',
    ar: 'هم يصنعون طعاماً.',
    uk: 'Вони виробляють їжу.',
    ru: 'Они производят еду.',
  },
  p2_one_b: {
    en: 'Cheese. Butter. Bread. Charcuterie. Sauces. Smoked fish.',
    ar: 'جبن. زبدة. خبز. لحوم مقدّدة. صلصات. سمك مدخّن.',
    uk: 'Сир. Масло. Хліб. М\'ясні делікатеси. Соуси. Копчена риба.',
    ru: 'Сыр. Масло. Хлеб. Мясные деликатесы. Соусы. Копчёная рыба.',
  },
  p2_two_a: {
    en: 'Today they track everything on paper and Excel.',
    ar: 'اليوم يتتبّعون كل شيء على ورق وملفات Excel.',
    uk: 'Сьогодні вони все відстежують на папері та в Excel.',
    ru: 'Сегодня они всё отслеживают на бумаге и в Excel.',
  },
  p2_two_b: {
    en: '14 spreadsheets. 6 notebooks. One QA manager who knows where everything is.',
    ar: '١٤ جدول بيانات. ٦ دفاتر ملاحظات. مديرة جودة واحدة تعرف مكان كل شيء.',
    uk: '14 електронних таблиць. 6 зошитів. Одна менеджерка з якості, яка знає, де все.',
    ru: '14 электронных таблиц. 6 тетрадей. Один менеджер по качеству, который знает, где всё.',
  },
  p2_three_a: {
    en: 'Keystone replaces all of that with one screen.',
    ar: 'يستبدل Keystone كل ذلك بشاشة واحدة.',
    uk: 'Keystone замінює це все одним екраном.',
    ru: 'Keystone заменяет всё это одним экраном.',
  },
  p2_three_b: {
    en: 'Track every kilogram. Pass every audit. Sleep on Sundays.',
    ar: 'تتبّع كل كيلوغرام. اجتز كل تدقيق. نم يوم الأحد.',
    uk: 'Відстежуйте кожен кілограм. Проходьте кожен аудит. Спіть у неділю.',
    ru: 'Отслеживайте каждый килограмм. Проходите каждый аудит. Спите в воскресенье.',
  },
  p2_kicker: {
    en: 'If they can run a factory, they can run Keystone. That is the whole pitch.',
    ar: 'إذا كانوا قادرين على إدارة مصنع، فهم قادرون على استخدام Keystone. هذا هو العرض كاملاً.',
    uk: 'Якщо вони можуть керувати фабрикою, вони можуть користуватись Keystone. Ось і вся презентація.',
    ru: 'Если они могут управлять фабрикой, они могут пользоваться Keystone. Вот и вся презентация.',
  },

  // ─── Page 3, ICP ─────────────────────────────────────────────────
  p3_section: { en: '04 · The buyer', ar: '٠٤ · المشتري', uk: '04 · Покупець', ru: '04 · Покупатель' },
  p3_title: {
    en: 'The person you are looking for.',
    ar: 'الشخص الذي تبحث عنه.',
    uk: 'Людина, яку ви шукаєте.',
    ru: 'Человек, которого вы ищете.',
  },
  p3_role_label: { en: 'Role', ar: 'الدور', uk: 'Роль', ru: 'Должность' },
  p3_role: {
    en: 'Owner or Operations Manager of a small food factory',
    ar: 'مالك أو مدير عمليات في مصنع أغذية صغير',
    uk: 'Власник або менеджер з операцій малого харчового виробництва',
    ru: 'Владелец или менеджер по операциям малого пищевого производства',
  },
  p3_age_label: { en: 'Age', ar: 'العمر', uk: 'Вік', ru: 'Возраст' },
  p3_age: { en: '40 to 65', ar: 'من ٤٠ إلى ٦٥', uk: 'Від 40 до 65', ru: 'От 40 до 65' },
  p3_loc_label: { en: 'Where', ar: 'الموقع', uk: 'Де', ru: 'Где' },
  p3_loc: {
    en: 'Ireland · United Kingdom · small-town setting',
    ar: 'أيرلندا · المملكة المتحدة · بلدات صغيرة',
    uk: 'Ірландія · Велика Британія · невелике містечко',
    ru: 'Ирландия · Великобритания · небольшой город',
  },
  p3_team_label: { en: 'Team size', ar: 'حجم الفريق', uk: 'Розмір команди', ru: 'Размер команды' },
  p3_team: {
    en: '5 to 50 people on the floor',
    ar: 'من ٥ إلى ٥٠ شخصاً في الموقع',
    uk: 'Від 5 до 50 людей на виробництві',
    ru: 'От 5 до 50 человек на производстве',
  },
  p3_pain_label: { en: 'Their pain', ar: 'مشكلتهم', uk: 'Їхній біль', ru: 'Их боль' },
  p3_pain: {
    en: 'Spends Sundays catching up on paperwork',
    ar: 'يقضي أيام الأحد في إنجاز الأوراق المتأخّرة',
    uk: 'Проводить неділі, доганяючи паперову роботу',
    ru: 'Проводит воскресенья, догоняя бумажную работу',
  },
  p3_want_label: { en: 'What they want', ar: 'ما يريدونه', uk: 'Чого вони хочуть', ru: 'Чего они хотят' },
  p3_want: {
    en: 'To stop spending Sundays catching up on paperwork',
    ar: 'التوقف عن قضاء أيام الأحد في إنجاز الأوراق',
    uk: 'Перестати проводити неділі за паперовою роботою',
    ru: 'Перестать проводить воскресенья за бумажной работой',
  },
  p3_personas_label: { en: 'The four types you will meet', ar: 'الأنواع الأربعة التي ستقابلهم', uk: 'Чотири типи, з якими ви зустрінетесь', ru: 'Четыре типа, которых вы встретите' },
  p3_persona_cheese: { en: 'Cheesemaker', ar: 'صانع الجبن', uk: 'Сировар', ru: 'Сыровар' },
  p3_persona_bakery: { en: 'Bakery owner', ar: 'صاحب مخبز', uk: 'Власник пекарні', ru: 'Владелец пекарни' },
  p3_persona_butcher: { en: 'Charcutier / butcher', ar: 'بائع لحوم', uk: 'Ковбасник / м\'ясник', ru: 'Колбасник / мясник' },
  p3_persona_sauce: { en: 'Sauce / preserve maker', ar: 'صانع الصلصات والمعلّبات', uk: 'Виробник соусів і консервів', ru: 'Производитель соусов и консервов' },
  p3_kicker: {
    en: 'They are not tech buyers. They are food people. Talk like one.',
    ar: 'هم ليسوا مشتري تقنية. هم أهل غذاء. تحدّث مثلهم.',
    uk: 'Вони не покупці технологій. Вони, люди харчового виробництва. Розмовляйте відповідно.',
    ru: 'Они не покупатели технологий. Они, люди пищевого производства. Говорите соответственно.',
  },

  // ─── Page 4, What Keystone does ──────────────────────────────────
  p4_section: { en: '05 · What it does', ar: '٠٥ · ماذا يفعل', uk: '05 · Що воно робить', ru: '05 · Что оно делает' },
  p4_title: {
    en: 'It follows every kilogram of food, from the farm to the shop.',
    ar: 'يتتبّع كل كيلوغرام من الغذاء، من المزرعة إلى المتجر.',
    uk: 'Воно відстежує кожен кілограм їжі від ферми до магазину.',
    ru: 'Оно отслеживает каждый килограмм еды от фермы до магазина.',
  },
  p4_step1: { en: 'Milk arrives', ar: 'الحليب يصل', uk: 'Молоко надходить', ru: 'Молоко поступает' },
  p4_step1_sub: { en: 'From the farm', ar: 'من المزرعة', uk: 'З ферми', ru: 'С фермы' },
  p4_step2: { en: 'Into the silo', ar: 'إلى الصومعة', uk: 'У силос', ru: 'В силос' },
  p4_step2_sub: { en: 'Mixed and stored', ar: 'يُمزَج ويُخزَّن', uk: 'Змішане та збережене', ru: 'Смешано и сохранено' },
  p4_step3: { en: 'Make day', ar: 'يوم الإنتاج', uk: 'День виробництва', ru: 'День производства' },
  p4_step3_sub: { en: 'Cheese is made', ar: 'يُصنَع الجبن', uk: 'Виробляють сир', ru: 'Производят сыр' },
  p4_step4: { en: 'Batch + cellar', ar: 'الدفعة والقبو', uk: 'Партія + сховище', ru: 'Партия + хранилище' },
  p4_step4_sub: { en: 'Ages 4-12 weeks', ar: 'يُعتَّق ٤–١٢ أسبوعاً', uk: 'Визріває 4-12 тижнів', ru: 'Созревает 4-12 недель' },
  p4_step5: { en: 'Dispatch', ar: 'الشحن', uk: 'Відвантаження', ru: 'Отгрузка' },
  p4_step5_sub: { en: 'To Tesco, Aldi, Lidl', ar: 'إلى Tesco و Aldi و Lidl', uk: 'До Tesco, Aldi, Lidl', ru: 'В Tesco, Aldi, Lidl' },
  p4_kicker_label: { en: 'The whole chain. In 90 seconds.', ar: 'السلسلة كاملة. خلال ٩٠ ثانية.', uk: 'Весь ланцюг. За 90 секунд.', ru: 'Вся цепочка. За 90 секунд.' },
  p4_kicker_body: {
    en: 'When a buyer rings to ask "which batches contain salt lot 2407?", Keystone answers in 90 seconds. Excel takes 4 hours and a panic attack.',
    ar: 'عندما يتّصل المشتري ليسأل "أي دفعات تحتوي على ملح من المجموعة ٢٤٠٧؟"، يجيب Keystone خلال ٩٠ ثانية. أمّا Excel فيستغرق ٤ ساعات ونوبة هلع.',
    uk: 'Коли покупець телефонує запитати «які партії містять сіль з лоту 2407?», Keystone відповідає за 90 секунд. Excel забирає 4 години та панічну атаку.',
    ru: 'Когда покупатель звонит спросить «какие партии содержат соль из лота 2407?», Keystone отвечает за 90 секунд. Excel занимает 4 часа и паническую атаку.',
  },

  // ─── Page 5, How to talk ─────────────────────────────────────────
  p5_section: { en: '07 · How to talk about it', ar: '٠٧ · كيف تتحدّث عنه', uk: '07 · Як говорити про це', ru: '07 · Как говорить об этом' },
  p5_title: {
    en: 'Their language. Not ours.',
    ar: 'لغتهم. ليس لغتنا.',
    uk: 'Їхня мова. Не наша.',
    ru: 'Их язык. Не наш.',
  },
  p5_say_label: { en: 'Say this', ar: 'قل هذا', uk: 'Кажіть це', ru: 'Говорите это' },
  p5_dont_label: { en: 'Never say this', ar: 'لا تقل هذا أبداً', uk: 'Ніколи не кажіть це', ru: 'Никогда не говорите это' },
  p5_say: {
    en: [
      'Are you still on Excel for batch tracking?',
      'How long does a mock recall take you today?',
      'We work with Cashel Blue. Same problems, smaller team.',
      'No per-user fees. One price. All modules.',
      'Founder takes the first call. No SDR. No chatbot.',
    ],
    ar: [
      'هل لا تزالون تستخدمون Excel لتتبّع الدفعات؟',
      'كم تستغرق تجربة استرجاع المنتجات لديكم اليوم؟',
      'نحن نعمل مع Cashel Blue. نفس المشكلات، فريق أصغر.',
      'لا توجد رسوم لكل مستخدم. سعر واحد. كل الوحدات.',
      'يأخذ المؤسس المكالمة الأولى. لا مندوبي مبيعات. لا روبوت محادثة.',
    ],
    uk: [
      'Ви все ще на Excel для відстеження партій?',
      'Скільки часу займає у вас навчальне відкликання сьогодні?',
      'Ми працюємо з Cashel Blue. Ті ж проблеми, менша команда.',
      'Жодних платежів за користувача. Одна ціна. Усі модулі.',
      'Засновник бере перший дзвінок. Жодних SDR. Жодних чат-ботів.',
    ],
    ru: [
      'Вы всё ещё пользуетесь Excel для отслеживания партий?',
      'Сколько времени у вас занимает учебный отзыв сегодня?',
      'Мы работаем с Cashel Blue. Те же проблемы, команда меньше.',
      'Никаких платежей за пользователя. Одна цена. Все модули.',
      'Основатель берёт первый звонок. Никаких SDR. Никаких чат-ботов.',
    ],
  },
  p5_dont: {
    en: [
      '"AI-powered platform"',
      '"Cloud-native digital transformation"',
      '"Enterprise-grade ERP"',
      '"Disrupting the food industry"',
      '"Synergies across the value chain"',
    ],
    ar: [
      '"منصة مدعومة بالذكاء الاصطناعي"',
      '"تحوّل رقمي سحابي الأصل"',
      '"نظام ERP بمستوى المؤسسات"',
      '"إحداث ثورة في صناعة الأغذية"',
      '"تكامل عبر سلسلة القيمة"',
    ],
    uk: [
      '«Платформа на основі ШІ»',
      '«Хмарна цифрова трансформація»',
      '«ERP корпоративного класу»',
      '«Перевертаємо харчову індустрію»',
      '«Синергії в усьому ланцюгу створення вартості»',
    ],
    ru: [
      '«Платформа на основе ИИ»',
      '«Облачная цифровая трансформация»',
      '«ERP корпоративного класса»',
      '«Переворачиваем пищевую индустрию»',
      '«Синергия по всей цепочке создания стоимости»',
    ],
  },
  p5_kicker: {
    en: 'They have heard "transformation" 50 times. They have never bought it. Speak like a person.',
    ar: 'لقد سمعوا كلمة "تحوّل" ٥٠ مرة. لم يشتروها قط. تحدّث كإنسان.',
    uk: 'Вони чули слово «трансформація» 50 разів. Жодного разу не купили. Розмовляйте як людина.',
    ru: 'Они слышали слово «трансформация» 50 раз. Ни разу не купили. Говорите как человек.',
  },

  // ─── Page 6, 5 questions ─────────────────────────────────────────
  p6_section: { en: '08 · The 5 questions you will be asked', ar: '٠٨ · الأسئلة الخمسة التي ستُسأل عنها', uk: '08 · 5 запитань, які вам поставлять', ru: '08 · 5 вопросов, которые вам зададут' },
  p6_title: {
    en: 'Memorise these. Don\'t improvise.',
    ar: 'احفظها. لا ترتجل.',
    uk: 'Запам\'ятайте їх. Не імпровізуйте.',
    ru: 'Запомните их. Не импровизируйте.',
  },
  p6_q1: { en: 'What does it cost?', ar: 'كم يكلّف؟', uk: 'Скільки це коштує?', ru: 'Сколько это стоит?' },
  p6_a1: {
    en: '€790/month single site, all-in. €1,290/month multi-site. €4,950 one-off setup. Optional 30-day pilot at €2,500 (50% refundable).',
    ar: '٧٩٠ يورو شهرياً لموقع واحد، شامل كل شيء. ١٢٩٠ يورو شهرياً لمواقع متعدّدة. ٤٩٥٠ يورو إعداد لمرة واحدة. تجربة اختيارية لمدّة ٣٠ يوماً بـ ٢٥٠٠ يورو (٥٠٪ قابلة للاسترداد).',
    uk: '€790/місяць за одну виробничу площадку, все включено. €1,290/місяць за кілька. €4,950 одноразово за встановлення. Опціонально 30-денний пілот за €2,500 (50% повертається).',
    ru: '€790/месяц за одну площадку, всё включено. €1,290/месяц за несколько. €4,950 разово за установку. Опционально 30-дневный пилот за €2,500 (50% возвращается).',
  },
  p6_q2: { en: 'Will I lose my data?', ar: 'هل سأفقد بياناتي؟', uk: 'Чи втрачу я свої дані?', ru: 'Потеряю ли я свои данные?' },
  p6_a2: {
    en: 'No. We migrate 12 months of historical batches as part of setup. You keep your old files too, nothing is deleted.',
    ar: 'لا. نقوم بنقل ١٢ شهراً من بيانات الدفعات السابقة ضمن الإعداد. تحتفظون أيضاً بملفّاتكم القديمة, لا يُحذف شيء.',
    uk: 'Ні. Ми переносимо 12 місяців історичних партій у рамках встановлення. Ви також зберігаєте свої старі файли, нічого не видаляється.',
    ru: 'Нет. Мы переносим 12 месяцев исторических партий в рамках установки. Вы также сохраняете свои старые файлы, ничего не удаляется.',
  },
  p6_q3: { en: 'How long to install?', ar: 'كم تستغرق عملية التركيب؟', uk: 'Скільки часу займає встановлення?', ru: 'Сколько времени занимает установка?' },
  p6_a3: {
    en: 'Go-live in 30 days from contract signed. First two weeks: we walk your floor and map workflows. Last two weeks: data migration, customer SKU mapping, training.',
    ar: 'بدء التشغيل خلال ٣٠ يوماً من توقيع العقد. الأسبوعان الأوّلان: نسير في موقعك ونرسم خرائط العمل. الأسبوعان الأخيران: نقل البيانات، ربط أصناف العملاء، التدريب.',
    uk: 'Запуск через 30 днів після підписання договору. Перші два тижні: ходимо вашим виробництвом і складаємо мапу процесів. Останні два тижні: міграція даних, прив\'язка SKU клієнтів, навчання.',
    ru: 'Запуск через 30 дней после подписания договора. Первые две недели: ходим по вашему производству и составляем карту процессов. Последние две недели: миграция данных, привязка SKU клиентов, обучение.',
  },
  p6_q4: { en: 'Who else uses it?', ar: 'من يستخدمه أيضاً؟', uk: 'Хто ще ним користується?', ru: 'Кто ещё им пользуется?' },
  p6_a4: {
    en: 'Cashel Farmhouse Cheesemakers in Tipperary, Ireland. A multi-award-winning farmhouse dairy. Reference call available on request, they say yes.',
    ar: 'مزرعة Cashel Farmhouse Cheesemakers في تيبيراري، أيرلندا. مصنع ألبان فائز بعدّة جوائز. مكالمة مرجعيّة متاحة عند الطلب, وهم يوافقون.',
    uk: 'Cashel Farmhouse Cheesemakers у Тіпперері, Ірландія. Багаторазовий лауреат премій у молочній галузі. Референс-дзвінок доступний за запитом, вони погоджуються.',
    ru: 'Cashel Farmhouse Cheesemakers в Типперэри, Ирландия. Многократный лауреат премий в молочной отрасли. Референс-звонок доступен по запросу, они соглашаются.',
  },
  p6_q5: { en: 'Can I leave if it doesn\'t work?', ar: 'هل يمكنني المغادرة إذا لم يعمل النظام؟', uk: 'Чи можу я піти, якщо не спрацює?', ru: 'Могу ли я уйти, если не сработает?' },
  p6_a5: {
    en: 'Yes. Month-to-month after the first year. 30 days notice. Your data exports as a clean spreadsheet pack. No hostage situation.',
    ar: 'نعم. شهراً بشهر بعد السنة الأولى. إشعار قبل ٣٠ يوماً. تُصدَّر بياناتكم في حزمة جداول بيانات نظيفة. لا احتجاز.',
    uk: 'Так. Помісячно після першого року. Сповіщення за 30 днів. Ваші дані експортуються чистим пакетом таблиць. Жодного утримання.',
    ru: 'Да. Помесячно после первого года. Уведомление за 30 дней. Ваши данные экспортируются чистым пакетом таблиц. Никакого удержания.',
  },

  // ─── Page 7, Handover ────────────────────────────────────────────
  p7_section: { en: '09 · How to hand over a hot lead', ar: '٠٩ · كيف تسلّم عميلاً جاهزاً', uk: '09 · Як передати гарячий лід', ru: '09 · Как передать горячий лид' },
  p7_title: {
    en: 'Three steps. Your job ends at step 1.',
    ar: 'ثلاث خطوات. مهمّتك تنتهي عند الخطوة الأولى.',
    uk: 'Три кроки. Ваша робота закінчується на першому.',
    ru: 'Три шага. Ваша работа заканчивается на первом.',
  },
  p7_step1_title: {
    en: 'Get three things',
    ar: 'احصل على ثلاثة أشياء',
    uk: 'Отримайте три речі',
    ru: 'Получите три вещи',
  },
  p7_step1_body: {
    en: 'Their name. Their company. Their phone number. That\'s it. Do not try to demo. Do not quote pricing differently. Do not promise features.',
    ar: 'الاسم. الشركة. رقم الهاتف. هذا كل شيء. لا تحاول إجراء عرض توضيحي. لا تذكر الأسعار بشكل مختلف. لا تعد بميّزات.',
    uk: 'Їх ім\'я. Назва компанії. Номер телефону. Все. Не намагайтеся проводити демо. Не озвучуйте інші ціни. Не обіцяйте функцій.',
    ru: 'Их имя. Название компании. Номер телефона. Всё. Не пытайтесь проводить демо. Не озвучивайте другие цены. Не обещайте функций.',
  },
  p7_step2_title: {
    en: 'Send to Asif',
    ar: 'أرسل إلى آصف',
    uk: 'Надішліть Асіфу',
    ru: 'Отправьте Асифу',
  },
  p7_step2_body: {
    en: 'WhatsApp the three things, plus one line of context ("Was on Excel · Tesco supplier · BRCGS due in March"). Within 5 minutes if the lead is on the phone with you. Within an hour otherwise.',
    ar: 'أرسل عبر واتساب الأشياء الثلاثة، مع سطر سياق واحد ("كان يستخدم Excel · مورّد لـ Tesco · تدقيق BRCGS في مارس"). خلال ٥ دقائق إذا كان العميل على الهاتف معك. خلال ساعة في الحالات الأخرى.',
    uk: 'Надішліть у WhatsApp три речі та один рядок контексту («Був на Excel · постачальник Tesco · BRCGS у березні»). Протягом 5 хвилин, якщо лід досі на лінії. Протягом години в інших випадках.',
    ru: 'Отправьте в WhatsApp три вещи и одну строку контекста («Был на Excel · поставщик Tesco · BRCGS в марте»). В течение 5 минут, если лид всё ещё на линии. В течение часа в остальных случаях.',
  },
  p7_step3_title: {
    en: 'Asif takes the call',
    ar: 'آصف يجري المكالمة',
    uk: 'Асіф проводить дзвінок',
    ru: 'Асиф проводит звонок',
  },
  p7_step3_body: {
    en: 'Asif personally calls every qualified lead within one business day. 20 minutes. Founder-to-owner. Reference call with Cashel Blue offered on the same call if there is interest.',
    ar: 'يتّصل آصف شخصياً بكل عميل مؤهَّل خلال يوم عمل واحد. عشرون دقيقة. مؤسّس إلى مالك. تُعرَض مكالمة مرجعيّة مع Cashel Blue في نفس المكالمة إذا كان هناك اهتمام.',
    uk: 'Асіф особисто телефонує кожному кваліфікованому ліду протягом одного робочого дня. 20 хвилин. Засновник з власником. Референс-дзвінок з Cashel Blue пропонується в тому ж дзвінку, якщо є інтерес.',
    ru: 'Асиф лично звонит каждому квалифицированному лиду в течение одного рабочего дня. 20 минут. Основатель, владельцу. Референс-звонок с Cashel Blue предлагается в том же звонке, если есть интерес.',
  },
  p7_kicker: {
    en: 'Bad sales people try to close. Good sales people pass the lead clean.',
    ar: 'مندوبو المبيعات السيّئون يحاولون الإغلاق. الجيّدون يسلّمون العميل بشكل نظيف.',
    uk: 'Погані продавці намагаються закрити. Хороші передають лід чисто.',
    ru: 'Плохие продавцы пытаются закрыть. Хорошие передают лид чисто.',
  },

  // ─── Page 8, Back cover ──────────────────────────────────────────
  p8_section: { en: '10 · Cheat sheet', ar: '١٠ · الورقة المرجعية', uk: '10 · Шпаргалка', ru: '10 · Шпаргалка' },
  p8_title: {
    en: 'Pin this above your desk.',
    ar: 'علّق هذا فوق مكتبك.',
    uk: 'Прикріпіть це над столом.',
    ru: 'Прикрепите это над столом.',
  },
  p8_we: { en: 'WE ARE', ar: 'نحن', uk: 'МИ', ru: 'МЫ' },
  p8_we_body: {
    en: 'Software for small Irish & UK food factories. Built side-by-side with Cashel Blue.',
    ar: 'برنامج لمصانع الأغذية الصغيرة في أيرلندا والمملكة المتحدة. مبنيّ بالتعاون مع Cashel Blue.',
    uk: 'Програмне забезпечення для малих харчових виробництв Ірландії та Великої Британії. Створене разом із Cashel Blue.',
    ru: 'Программное обеспечение для малых пищевых производств Ирландии и Великобритании. Создано вместе с Cashel Blue.',
  },
  p8_buyer: { en: 'THE BUYER', ar: 'المشتري', uk: 'ПОКУПЕЦЬ', ru: 'ПОКУПАТЕЛЬ' },
  p8_buyer_body: {
    en: 'Owner or Ops Manager. 5-50 staff. Excel + paper today. Tesco / Aldi / Lidl supplier.',
    ar: 'مالك أو مدير عمليات. ٥–٥٠ موظفاً. يستخدم Excel والورق اليوم. مورّد لـ Tesco / Aldi / Lidl.',
    uk: 'Власник або менеджер з операцій. 5-50 співробітників. Сьогодні Excel + папір. Постачальник Tesco / Aldi / Lidl.',
    ru: 'Владелец или менеджер по операциям. 5-50 сотрудников. Сегодня Excel + бумага. Поставщик Tesco / Aldi / Lidl.',
  },
  p8_pitch: { en: 'THE PITCH', ar: 'العرض', uk: 'ПРЕЗЕНТАЦІЯ', ru: 'ПРЕЗЕНТАЦИЯ' },
  p8_pitch_body: {
    en: 'One screen instead of 14 spreadsheets. Recall in 90 seconds. €790/month. Cancel any time.',
    ar: 'شاشة واحدة بدلاً من ١٤ جدولاً. استرجاع المنتج خلال ٩٠ ثانية. ٧٩٠ يورو شهرياً. إلغاء في أي وقت.',
    uk: 'Один екран замість 14 таблиць. Відкликання за 90 секунд. €790/місяць. Скасування у будь-який час.',
    ru: 'Один экран вместо 14 таблиц. Отзыв за 90 секунд. €790/месяц. Отмена в любое время.',
  },
  p8_hand: { en: 'THE HANDOVER', ar: 'التسليم', uk: 'ПЕРЕДАЧА', ru: 'ПЕРЕДАЧА' },
  p8_hand_body: {
    en: 'Name. Company. Phone. → WhatsApp Asif within the hour. Done.',
    ar: 'الاسم. الشركة. الهاتف. ← أرسل لآصف عبر واتساب خلال ساعة. انتهت المهمّة.',
    uk: 'Ім\'я. Компанія. Телефон. → WhatsApp Асіфу протягом години. Готово.',
    ru: 'Имя. Компания. Телефон. → WhatsApp Асифу в течение часа. Готово.',
  },
  p8_kicker: {
    en: 'You are not selling software. You are giving a stressed food-factory owner their Sunday back.',
    ar: 'أنت لا تبيع برنامجاً. أنت تعيد لمالك مصنع غذاء مرهَق يومَ الأحد.',
    uk: 'Ви не продаєте програмне забезпечення. Ви повертаєте знесиленому власнику харчової фабрики його неділю.',
    ru: 'Вы не продаёте программное обеспечение. Вы возвращаете уставшему владельцу пищевой фабрики его воскресенье.',
  },

  // ─── Visual page 1, entering data ────────────────────────────────
  vis1_section: {
    en: '03 · What you will see',
    ar: '٠٣ · ما ستراه على الشاشة',
    uk: '03 · Що ви побачите на екрані',
    ru: '03 · Что вы увидите на экране',
  },
  vis1_title: {
    en: 'Entering batches, orders and codes.',
    ar: 'إدخال الدفعات والطلبات والأكواد.',
    uk: 'Введення партій, замовлень і кодів.',
    ru: 'Ввод партий, заказов и кодов.',
  },
  vis1_a_title: { en: 'Sales order entry', ar: 'إدخال أمر البيع', uk: 'Введення замовлення', ru: 'Ввод заказа на продажу' },
  vis1_a_caption: {
    en: 'Pick a customer. Their product codes auto-fill. No retyping. No spreadsheet errors.',
    ar: 'اختر العميل. تُملأ أكواد منتجاته تلقائياً. لا إعادة كتابة. لا أخطاء جداول بيانات.',
    uk: 'Виберіть клієнта. Його коди продуктів заповнюються автоматично. Жодного повторного вводу. Жодних помилок Excel.',
    ru: 'Выберите клиента. Его коды товаров заполняются автоматически. Никакого повторного ввода. Никаких ошибок Excel.',
  },
  vis1_b_title: { en: 'Cheese batches', ar: 'دفعات الجبن', uk: 'Партії сиру', ru: 'Партии сыра' },
  vis1_b_caption: {
    en: 'Every wheel on one row, internal batch code, make day, expiry, customer destination. Searchable.',
    ar: 'كل قرص جبن في صفّ واحد, الكود الداخلي، يوم الإنتاج، تاريخ الانتهاء، العميل. قابل للبحث.',
    uk: 'Кожна головка в одному рядку, внутрішній код, день виробництва, термін, клієнт. З пошуком.',
    ru: 'Каждая головка в одной строке, внутренний код, день производства, срок, клиент. С поиском.',
  },
  vis1_c_title: { en: 'Inward deliveries', ar: 'الواردات', uk: 'Вхідні поставки', ru: 'Входящие поставки' },
  vis1_c_caption: {
    en: 'The supplier batch code goes in here. It follows the milk into every finished wheel.',
    ar: 'كود دفعة المورد يُدخَل هنا. ويتبع الحليب إلى كل قرص جبن نهائي.',
    uk: 'Код партії постачальника вводиться тут. Він супроводжує молоко аж до готової головки.',
    ru: 'Код партии поставщика вводится здесь. Он сопровождает молоко вплоть до готовой головки.',
  },
  vis1_d_title: { en: 'Customer product codes', ar: 'أكواد منتجات العميل', uk: 'Коди продуктів клієнта', ru: 'Коды продуктов клиента' },
  vis1_d_caption: {
    en: 'Internal code on the left → customer\'s code on the right. Two languages, one map. Audit-proof.',
    ar: 'الكود الداخلي على اليسار ← كود العميل على اليمين. لغتان، خريطة واحدة. مقاومة للتدقيق.',
    uk: 'Внутрішній код ліворуч → код клієнта праворуч. Дві мови, одна мапа. Захищено від аудиту.',
    ru: 'Внутренний код слева → код клиента справа. Два языка, одна карта. Защита от аудита.',
  },
  vis1_kicker: {
    en: 'The buyer never asks for the internal code. Keystone speaks both languages, yours and the retailer\'s.',
    ar: 'العميل لا يطلب الكود الداخلي أبداً. يتحدّث Keystone اللغتين, لغتك ولغة المتجر.',
    uk: 'Покупець ніколи не запитує внутрішній код. Keystone розмовляє двома мовами, вашою та мережі.',
    ru: 'Покупатель никогда не спрашивает внутренний код. Keystone говорит на двух языках, вашем и сети.',
  },

  // ─── Visual page 2, pipeline / dispatch / recall ─────────────────
  vis2_section: {
    en: '06 · What you will see',
    ar: '٠٦ · ما ستراه على الشاشة',
    uk: '06 · Що ви побачите на екрані',
    ru: '06 · Что вы увидите на экране',
  },
  vis2_title: {
    en: 'Pipeline, dispatch and recall.',
    ar: 'خطّ الطلبات، الشحن، والاسترجاع.',
    uk: 'Конвеєр замовлень, відвантаження та відкликання.',
    ru: 'Конвейер заказов, отгрузка и отзыв.',
  },
  vis2_a_title: { en: 'Order pipeline', ar: 'خطّ الطلبات', uk: 'Конвеєр замовлень', ru: 'Конвейер заказов' },
  vis2_a_caption: {
    en: 'Every order, today, this week, next month, on one calendar. Drag, edit, plan production.',
    ar: 'كل الطلبات, اليوم، هذا الأسبوع، الشهر القادم, على تقويم واحد. اسحب، عدّل، خطّط الإنتاج.',
    uk: 'Усі замовлення, сьогодні, цього тижня, наступного місяця, в одному календарі. Перетягуйте, редагуйте, плануйте.',
    ru: 'Все заказы, сегодня, на неделе, в следующем месяце, в одном календаре. Перетаскивайте, редактируйте, планируйте.',
  },
  vis2_b_title: { en: 'Dispatch note', ar: 'بيان الشحن', uk: 'Накладна на відвантаження', ru: 'Накладная на отгрузку' },
  vis2_b_caption: {
    en: 'Customer, address, every batch code, every use-by date, printed, locked, audit-ready.',
    ar: 'العميل، العنوان، كل كود دفعة، كل تاريخ صلاحية, مطبوع، مقفل، جاهز للتدقيق.',
    uk: 'Клієнт, адреса, кожен код партії, кожен термін придатності, надруковано, заблоковано, готово до аудиту.',
    ru: 'Клиент, адрес, каждый код партии, каждый срок годности, напечатано, заблокировано, готово к аудиту.',
  },
  vis2_c_title: { en: 'Mock recall', ar: 'اختبار استرجاع', uk: 'Навчальне відкликання', ru: 'Учебный отзыв' },
  vis2_c_caption: {
    en: 'Type one supplier lot. Get every batch, every dispatch, every customer affected, under 90 seconds.',
    ar: 'اكتب رقم دفعة المورد. احصل على كل دفعة وكل شحنة وكل عميل متأثّر, في أقل من ٩٠ ثانية.',
    uk: 'Введіть один лот постачальника. Отримайте всі партії, відвантаження і клієнтів, менше ніж за 90 секунд.',
    ru: 'Введите один лот поставщика. Получите все партии, отгрузки и клиентов, менее чем за 90 секунд.',
  },
  vis2_d_title: { en: 'Reports', ar: 'التقارير', uk: 'Звіти', ru: 'Отчёты' },
  vis2_d_caption: {
    en: 'Make-day summary, milk usage, supplier-lot trace, the audit answers, pre-printed.',
    ar: 'ملخّص يوم الإنتاج، استهلاك الحليب، تتبّع لوت المورد, إجابات التدقيق، مطبوعة مسبقاً.',
    uk: 'Підсумок дня виробництва, витрати молока, трасування лоту постачальника, відповіді для аудиту вже надруковані.',
    ru: 'Сводка дня производства, расход молока, трассировка лота поставщика, ответы для аудита уже напечатаны.',
  },
  vis2_kicker: {
    en: 'When BRCGS asks "trace lot 2407 in 90 seconds", point at this screen. Don\'t say "AI-powered". Just press the button.',
    ar: 'عندما يطلب BRCGS «تتبّع اللوت ٢٤٠٧ في ٩٠ ثانية»، أشِر إلى هذه الشاشة. لا تقل «مدعوم بالذكاء الاصطناعي». فقط اضغط الزر.',
    uk: 'Коли BRCGS просить «відстежити лот 2407 за 90 секунд», вкажіть на цей екран. Не кажіть «на основі ШІ». Просто натисніть кнопку.',
    ru: 'Когда BRCGS просит «отследить лот 2407 за 90 секунд», укажите на этот экран. Не говорите «на основе ИИ». Просто нажмите кнопку.',
  },
};

export function tr(key, lang) {
  const entry = TRANSLATIONS[key];
  if (!entry) return `[${key}]`;
  return entry[lang] || entry.en || `[${key}]`;
}
